import React from 'react';
import NorthEastIcon from '@mui/icons-material/NorthEast';

export default function Main() {
  return (
    <aside className="profile-column" id="home" aria-labelledby="profile-name">
      <img className="profile-image" src="/avatar.png" alt="K1r44's illustrated avatar" width="144" height="144" />
      <h1 id="profile-name">K1r44<span>.</span></h1>
      <p className="profile-role">Security analyst. <br />Pentester. Bug hunter.</p>
      <p className="profile-bio">CTF writeups and notes on web, network, and mobile security.</p>
      <div className="profile-links">
        <a href="https://github.com/k1r4-id" target="_blank" rel="noopener noreferrer">GitHub <NorthEastIcon /></a>
        <a href="https://www.linkedin.com/in/k1r4/" target="_blank" rel="noopener noreferrer">LinkedIn <NorthEastIcon /></a>
        <a href="mailto:akiratsuyoi2705@gmail.com">Email <NorthEastIcon /></a>
      </div>
      <a className="profile-about" href="#about">About me</a>
    </aside>
  );
}
